import * as React from "react";

export const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "quantity",
            label: t ? t("production.produced_packages") : "Ilość wyprodukowanych opakowań",
            type: "number",
            mandatory: true,
            column: 1,
        },
        {
            name: "endComment",
            label: t ? t("common.comments") : "Uwagi",
            type: "textarea",
            column: 1,
        },

    ]
});
